const IMAGE_1 = 'Piktogram Abtrieb';
const IMAGE_2 = 'Bildpfad';
const QUANTITY = 'Menge';
const SKU = 'Codenummer';
const DIMENSIONS = 'Dimensionen';
const TITLE_DE = 'Bezeichnung Shop DE';
const TITLE_EN = 'Bezeichnung Shop EN';
const SHOW_MORE_THRESHOLD = 5;

class CSVToTable extends HTMLElement {
	async connectedCallback() {
		this.fileURL = this.getAttribute('csv-url');
		if (!this.fileURL) {
			console.error('No CSV URL provided');
			this.style.display = 'none';
			return;
		}
		await this.loadData();
		this.render();
	}
	async loadData() {
		try {
			const response = await fetch(this.fileURL, { headers: { 'Content-Type': 'text/csv; charset=utf-8' } });
			const data = await response.text();
			this.data = data
				.split('\n')
				.map((row) => row.replace('\r', ''))
				.map((row) => row.split(';'));
			// removes " from cell if its at the start and end
			this.data = this.data.map((row) => row.map((cell) => cell.replaceAll('""', '"').replace(/^"(.*)"$/, '$1')));
			this.data = this.data.filter((row) => row.length > 1);
		} catch (error) {
			console.error('Error fetching CSV:', error);
			this.style.display = 'none';
		}
	}
	setIndexes() {
		this.indexes = {};
		this.data[0].forEach((columnName, index) => {
			this.indexes[columnName] = index;
		});
		this.columnOrder = [[IMAGE_1, IMAGE_2], [QUANTITY], [SKU], [DIMENSIONS], [TITLE_DE, TITLE_EN]];
		this.columnOrder = this.columnOrder.map((cellsName) => cellsName.map((cellName) => this.indexes[cellName]));
	}
	render() {
		if (!this.data) {
			console.error('No data to render');
			return;
		}
		this.setIndexes();
		this.tableBodyNode = this.querySelector('table tbody');
		let lastRow;
		let index = 0;
		const body = this.data.slice(1);
		body.forEach((row) => {
			const doesRowHasTitle = row[this.indexes[TITLE_DE]] !== '' || row[this.indexes[TITLE_EN]] !== '';
			if (doesRowHasTitle) {
				lastRow = this.createRow(row, index);
				this.tableBodyNode.appendChild(lastRow);
				index += 1;
			} else {
				this.addCellsToLastRow(row, lastRow);
			}
		});
		// hide show more button if there are no more than 5 rows
		this.closest('.parent-display')
			?.querySelector('.show-more-button')
			?.classList.toggle('hidden', index <= SHOW_MORE_THRESHOLD);
	}
	createRow(row, index) {
		const rowNode = document.createElement('tr');
		rowNode.classList.add('table-body__row');
		if (index > SHOW_MORE_THRESHOLD) {
			rowNode.classList.add('show-more-item', 'hidden');
		}
		const cells = this.columnOrder.map((cellIndexes) => cellIndexes.map((cellIndex) => row[cellIndex]));
		cells.forEach((cells, columnIndex) => {
			const cellNode = document.createElement('td');
			cellNode.classList.add('table-body__cell', `cell-${columnIndex + 1}`);
			const hasImages = cells.filter((cell) => cell.includes('https'));
			const imageAltText = row[this.indexes[TITLE_DE]] || row[this.indexes[TITLE_EN]] || '';
			if (hasImages.length > 0) {
				rowNode.classList.add(`table-body__row--${hasImages.length}-images`);
			}
			cells.forEach((cell, index) => {
				if (cell.includes('https')) {
					const cellContentNode = document.createElement('img');
					cellContentNode.classList.add(`cell-image-${index + 1}`);
					cellContentNode.src = cell;
					if (index === 1) {
						cellContentNode.alt = imageAltText;
					} else {
						cellContentNode.setAttribute('role', 'presentation');
					}
					cellNode.appendChild(cellContentNode);
				} else {
					const cellContentNode = document.createElement('span');
					cellContentNode.classList.add('cell-text', `cell-text-${index + 1}`);
					// add x to the quantity
					cellContentNode.textContent = columnIndex === 1 ? `${cell}x` : cell;
					cell.split(' ').length > 7 && rowNode.classList.add('table-body__row--long-text');
					cellNode.appendChild(cellContentNode);
				}
			});
			rowNode.appendChild(cellNode);
		});
		return rowNode;
	}
	addCellsToLastRow(row, lastRow) {
		if (!lastRow) return;
		const cells = this.columnOrder.map((cellIndexes) => cellIndexes.map((cellIndex) => row[cellIndex]));
		cells.forEach((cells, columnIndex) => {
			const cellNode = lastRow.querySelector(`.cell-${columnIndex + 1}`);
			lastRow.classList.add('table-body__row--multiple');
			const nonEmptyCells = cells.filter((cell) => cell);
			// If there is no SKU, add NO_SKU, so there is a placeholder
			if (nonEmptyCells.length == 0 && columnIndex === 2) {
				nonEmptyCells.push('NO_SKU');
			}
			nonEmptyCells.length > 0 && cellNode.classList.add('cell--multiple');
			nonEmptyCells.forEach((cell, index) => {
				const cellContentNode = document.createElement('span');
				cellContentNode.classList.add('cell-text', `cell-text-${index + 1}`);
				// add x to the quantity
				cellContentNode.textContent = columnIndex === 1 ? `${cell}x` : cell;
				if (cell === 'NO_SKU') {
					cellContentNode.classList.add('cell-text--no-sku');
				}
				cellNode.appendChild(cellContentNode);
			});
		});
	}
}

customElements.define('csv-to-table', CSVToTable);
